import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { DropdownsModule } from 'src/app/core/dropdowns/dropdowns.module';
import { FormsModalConfirmationModule } from 'src/app/forms-modal-confirmation/forms-modal-confirmation.module';
import { FormsModule } from '@angular/forms';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { MapSimLocationsComponent } from "./map-sim-locations.component";
import { SharedModule } from "../../shared.module";

@NgModule({
  declarations: [
    MapSimLocationsComponent
  ],
  imports: [
    CommonModule,
    DropdownsModule,
    FormsModalConfirmationModule,
    FormsModule,
    LeafletModule,
    SharedModule
  ],
  exports: [
    MapSimLocationsComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class MapSimLocationsModule { }
